import { InjectionToken } from '@angular/core';

export const PipelineToken = new InjectionToken('PipelineToken');
